import { render, staticRenderFns } from "./PagoExitoso.vue?vue&type=template&id=2ebe67a8&scoped=true"
import script from "./PagoExitoso.vue?vue&type=script&lang=js"
export * from "./PagoExitoso.vue?vue&type=script&lang=js"
import style0 from "./PagoExitoso.vue?vue&type=style&index=0&id=2ebe67a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe67a8",
  null
  
)

export default component.exports